import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { ApplicationConfig, provideZoneChangeDetection } from "@angular/core";
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from "@angular/router";
import Aura from '@primeng/themes/aura';
import { provideHighlightOptions } from 'ngx-highlightjs';
import { provideMarkdown } from "ngx-markdown";
// eslint-disable-next-line no-restricted-imports
import { provideToastr } from "ngx-toastr";
import { providePrimeNG } from 'primeng/config';
import { routes } from "./app-routing.module";
import { authInterceptor } from "@shared-angular/interceptors/auth.interceptor";
import { httpConcurrencyInterceptor } from "@shared-angular/interceptors/http-concurrency.service";
import { httpErrorInterceptor } from "@shared-angular/interceptors/http-error.interceptor";
import { httpLoggerInterceptor } from "@shared-angular/interceptors/http-logger.interceptor";
import { PortalLoginResolver } from "./shared/resolver/PortalLogin.resolver";
export const appConfig: ApplicationConfig = {
  providers: [
    providePrimeNG({
      theme: {
        options: {
          darkModeSelector: '.dark-mode'
        },
        preset: Aura
      }
    }),
    provideAnimationsAsync(),
    provideHighlightOptions({
      fullLibraryLoader: () => import('highlight.js')
    }),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    PortalLoginResolver,
    provideHttpClient(withInterceptors([httpLoggerInterceptor, authInterceptor, httpErrorInterceptor, httpConcurrencyInterceptor])),
    provideToastr({
      preventDuplicates: true,
      countDuplicates: true,
      includeTitleDuplicates: true,
      resetTimeoutOnDuplicate: true,
      progressBar: true,
      timeOut: 2000
    }),
    provideMarkdown()
  ]
};
